export function getImageUrl(image) {
  if (image?.includes('static')) {
    return image;
  } else if (image?.includes('s3fs-public')) {
    // return `${process.env.REACT_APP_WEBSITE_DRUPAL_URL}${image?.replaceAll("s3fs-public/", "")}`;
    return `${process.env.REACT_APP_WEBSITE_DRUPAL_URL}/sites/default/files/${image?.replaceAll('s3fs-public/', '')}`;
  }

  return `${process.env.REACT_APP_WEBSITE_DRUPAL_URL}${image?.replaceAll('', '')}`;
}

export function removeEmptySpace(value) {
  if (value) {
    return value.replaceAll(' ', '').toLowerCase();
  } else {
    return '';
  }
}

export function combineEnglishNameMenuTree(api1, api2) {
  return api1.map((item, index) => {
    // api2 -> en 유틸 헤더에서 sign in, sign up 등 특정 조건을 걸기 위해 영어 이름을 enTitle 필드에 추가
    const mergedItem = {
      ...item,
      enTitle: api2.find((el) => el.entity_id === item.entity_id)?.title,
    };

    if (item?.children && item?.children.length > 0) {
      mergedItem.children = combineEnglishNameMenuTree(item.children, api2[index].children);
    }

    return mergedItem;
  });
}
